import { type FC } from 'react'

import { experimentComponentCompileAndGetExperiment } from '../../../experiments/components/experimentComponentCompiler'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { experimentAccessorIsValidExperimentVariation } from '../../../experiments/model/experimentAccessor'
import { type StoryblokComponentProps } from '../../model/StoryblokComponentProps'
import { type StoryblokOptimizelyExperimentType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

import { StoryblokOptimizelyExperimentActivation } from './StoryblokOptimizelyExperimentActivation'

export const StoryblokOptimizelyExperiment: FC<
  StoryblokComponentProps<StoryblokOptimizelyExperimentType>
> = ({ blok }) => {
  const { experiments } = useExperimentsContext()

  const experiment = experimentComponentCompileAndGetExperiment(
    blok.name.split(/[,\s]+/u),
    experiments,
  )

  const { content, variation } = blok

  if (
    !experimentAccessorIsValidExperimentVariation(variation) ||
    variation !== experiment.variant
  ) {
    return null
  }

  return (
    <>
      {experiment.isEnabled ? (
        <StoryblokOptimizelyExperimentActivation
          experimentName={experiment.name}
        />
      ) : null}
      <StoryblokComponentsRenderer bloks={content} />
    </>
  )
}
